import { apiClient } from './api';
import { Company, CreateCompanyData, UpdateCompanyData, Contact, CreateContactData, PaginatedResponse, PaginationParams } from '../types';

export const companiesService = {
  // Get all companies
  getCompanies: async (params: PaginationParams = {}): Promise<PaginatedResponse<Company>> => {
    const response = await apiClient.get('/api/companies', { params });
    return {
      data: response.companies,
      pagination: response.pagination
    };
  },

  // Get company by ID
  getCompany: async (id: string): Promise<Company> => {
    const response = await apiClient.get(`/api/companies/${id}`);
    return response.company;
  },

  // Create new company
  createCompany: async (companyData: CreateCompanyData): Promise<Company> => {
    const response = await apiClient.post('/api/companies', companyData);
    return response.company;
  },

  // Update company
  updateCompany: async (id: string, companyData: UpdateCompanyData): Promise<Company> => {
    const response = await apiClient.put(`/api/companies/${id}`, companyData);
    return response.company;
  },

  // Delete company
  deleteCompany: async (id: string): Promise<{ message: string }> => {
    const response = await apiClient.delete(`/api/companies/${id}`);
    return { message: response.message || 'Company deleted successfully' };
  },

  // Toggle star status
  toggleStar: async (id: string): Promise<{ starred: boolean; message: string }> => {
    const response = await apiClient.patch(`/api/companies/${id}/star`);
    return {
      starred: response.starred,
      message: response.message || 'Star status updated'
    };
  },

  // Get company contacts
  getCompanyContacts: async (companyId: string, params: PaginationParams = {}): Promise<PaginatedResponse<Contact>> => {
    const response = await apiClient.get(`/api/companies/${companyId}/contacts`, { params });
    return {
      data: response.contacts,
      pagination: response.pagination
    };
  },

  // Create contact for company
  createCompanyContact: async (companyId: string, contactData: CreateContactData): Promise<Contact> => {
    const response = await apiClient.post(`/api/companies/${companyId}/contacts`, contactData);
    return response.contact;
  },

  // Get company statistics
  getCompanyStats: async (companyId: string): Promise<any> => {
    const response = await apiClient.get(`/api/companies/${companyId}/stats`);
    return response.stats;
  },
}; 